import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import HeaderBottom from "../../components/HomePage/HeaderBottom";

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 12; // You can change this value based on your preference

  useEffect(() => {
    fetch("https://marchtwo202501-5801b8caeb3a.herokuapp.com/posts")
      .then((res) => res.json())
      .then((data) => setPosts(data))
      .catch((error) => console.error("Error fetching posts:", error));
  }, []);

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = posts.slice(indexOfFirstPost, indexOfLastPost);

  const totalPages = Math.ceil(posts.length / postsPerPage);

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  return (
    <>
      <section className="hero blog_hero">
        <div className="hero__wrapper blog_hero__wrapper">
          <div className="container">
            <div className="row">
              <div>
                <h1>All Blog Posts.</h1>
              </div>
              <div className="mb-5">
                <ul>
                  <li>
                    <a href="/">Home</a>
                  </li>
                  <li>
                    <a href="/blog">
                      <i className="fad fa-long-arrow-right"></i>Blog
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <main className="main-wrapper min-vh-100">
        <div className="blog1-section-area py-5">
          <div className="container">
            <div className="row g-4">
              {currentPosts.map((post, index) => (
                <div
                  key={post._id}
                  className="col-lg-4 col-md-6 d-flex"
                  data-aos="zoom-out"
                  data-aos-duration={800 + index * 200}
                >
                  <div className="card border-0 shadow-lg rounded-3 ml-5 overflow-hidden h-100 d-flex flex-column">
                    <Link to={`/blog/${post.titleSlug}`}>
                      <img
                        src={post.featuredImage}
                        alt="Blog Thumbnail"
                        className="card-img-top"
                        style={{
                          height: "250px",
                          objectFit: "",
                          width: "100%",
                        }}
                      />
                    </Link>
                    <div className="card-body d-flex flex-column">
                      <div className="d-flex align-items-center mb-2">
                        <img
                          src="https://i.ibb.co/qYkZdbKQ/calendar-249.png"
                          alt="Calendar"
                          className="me-2"
                          style={{ width: "20px" }}
                        />
                        <span className="text-muted small">{post.postDate}</span>
                      </div>
                      <h1 className="">
                        <Link
                          to={`/blog/${post.titleSlug}`}
                          className="text-dark text-decoration-none"
                        >
                          {post.postTitle}
                        </Link>
                      </h1>
                      <div className="mt-auto">
                        <Link
                          to={`/blog/${post.titleSlug}`}
                          className="btn btn-primary custom-btn btn-sm fs-4 mt-2 mb-5"
                        >
                          Read More <i className="fa-solid fa-arrow-right ms-1" />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="text-center mt-4">
                <nav aria-label="Page navigation">
                  <ul className="pagination justify-content-center">
                    <li className="page-item">
                      <button
                        className="page-link"
                        onClick={handlePrev}
                        disabled={currentPage === 1}
                      >
                        Previous
                      </button>
                    </li>

                    {pageNumbers.map((number) => (
                      <li
                        key={number}
                        className={`page-item ${currentPage === number ? "active" : ""}`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageClick(number)}
                        >
                          {number}
                        </button>
                      </li>
                    ))}

                    <li className="page-item">
                      <button
                        className="page-link"
                        onClick={handleNext}
                        disabled={currentPage === totalPages}
                      >
                        Next
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            )}
          </div>
        </div>
      </main>
    </>
  );
};

export default Blog;
